/** @file Thai catalog (partial): any key missing here falls back to English. */
import type { PartialCatalog } from '../types';
import { autorigPanelTh } from './th/autorigPanelTh.data';
import { curvesTh } from './th/curvesTh.data';
import { docPanelsTh } from './th/docPanelsTh.data';
import { formsTh } from './th/formsTh.data';
import { liveTh } from './th/liveTh.data';
import { meshToolsTh } from './th/meshToolsTh.data';
import { projectsExtraTh } from './th/projectsExtraTh.data';
import { rigPanelsTh } from './th/rigPanelsTh.data';
import { settingsExtraTh } from './th/settingsExtraTh.data';
import { settingsScreenTh } from './th/settingsScreenTh.data';
import { timelineTh } from './th/timelineTh.data';
import { toolsTh } from './th/toolsTh.data';
import { viewportTh } from './th/viewportTh.data';
import { weightsTh } from './th/weightsTh.data';

/** Composed from the per-area parts under `catalogs/th/` at the same spread points as `en` (W3-03). */
export const th: PartialCatalog = {
  app: { title: 'Pose2D' },
  settings: {
    title: 'ตั้งค่า',
    language: 'ภาษาของหน้าจอ',
    languageName: 'ไทย',
    languageHint: 'ชื่อ bone, slot และ animation เป็นภาษาอังกฤษเสมอ',
    shortcuts: 'แป้นพิมพ์ลัด',
    theme: 'ธีม',
    themeDark: 'มืด',
    resetLayout: 'รีเซ็ตการจัดวางแผง',
    ...settingsExtraTh,
  },
  common: { save: 'บันทึก', cancel: 'ยกเลิก', delete: 'ลบ', undo: 'เลิกทำ', redo: 'ทำซ้ำ' },
  messages: { renamedLayers: 'เปลี่ยนชื่อ layer เป็น ASCII แล้ว {n} รายการ', renamedUnique: 'เปลี่ยนชื่อ layer ที่ชื่อซ้ำกับที่มีอยู่แล้ว {n} รายการ โดยเติมตัวเลขต่อท้ายชื่อ' },
  shell: { projects: 'โปรเจกต์', settings: 'ตั้งค่า', signOut: 'ออกจากระบบ', loading: 'กำลังโหลด…', notFound: 'ไม่มีหน้านี้', retry: 'ลองอีกครั้ง' },
  login: { title: 'เข้าสู่ระบบ Pose2D', username: 'ชื่อผู้ใช้', password: 'รหัสผ่าน', submit: 'เข้าสู่ระบบ' },
  projects: {
    title: 'โปรเจกต์', search: 'ค้นหาโปรเจกต์', sort: 'เรียงตาม', sortUpdated: 'แก้ไขล่าสุด', sortName: 'ชื่อ',
    showTrash: 'ดูถังขยะ', showActive: 'ดูโปรเจกต์', newName: 'ชื่อโปรเจกต์ใหม่', create: 'สร้าง',
    trash: 'ย้ายไปถังขยะ', empty: 'ยังไม่มีโปรเจกต์', meta: 'rev {rev} · {actor} · {date}',
    ...projectsExtraTh,
  },
  panels: {
    placeholder: 'แผงนี้จะมาใน wave ถัดไป',
    viewport: { title: 'วิวพอร์ต' },
    ...docPanelsTh,
    ...timelineTh,
    ...weightsTh,
    ...rigPanelsTh,
  },
  viewport: viewportTh,
  tools: { ...toolsTh, ...meshToolsTh },
  forms: formsTh,
  curves: curvesTh,
  ...settingsScreenTh,
  ...liveTh,
  ...autorigPanelTh,
  errors: {
    unauthorized: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง', rateLimited: 'ลองบ่อยเกินไป รออีก {seconds} วินาที',
    nameTaken: 'ชื่อ "{name}" ถูกใช้แล้ว', invalidName: '"{name}" ใช้เป็นชื่อไม่ได้: ใช้ตัวอักษร ASCII ตัวเลข - และ _',
    notFound: 'ไม่พบ: {ref}', generic: 'เกิดข้อผิดพลาด: {message}', crashed: 'มุมมองนี้ขัดข้อง',
  },
};
